import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { APIs } from 'src/app/config/api.constant';
import { AppConstant } from '../config/app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomergroupService {

  private dataSubject = new BehaviorSubject<string>('Initial data');
  public data$ = this.dataSubject.asObservable();

  constructor(
    private apiService: ApiService,
    private http: HttpClient
  ) { }

  sendData(data: string) {
    this.dataSubject.next(data);
  }

  getParkByCLAId() {
    return this.apiService.get(`${APIs.getParkByClaId}?claId=${localStorage.getItem('claAdminId')}`).pipe(map(response => {
      if (response.isValid) {
        // this.parkDropDownDetails.next(response.list);
        console.log(response.list);
      }
      return response;
    }))
  }

  createCustomerUserServiceGroup(body?: any): Observable<any> {
    return this.apiService.post(APIs.createServiceGroup, body).pipe(map(response => {
      return response;
    }));
  }

  getMainGroupList(): Observable<any> {
    return this.apiService.get(APIs.mainServiceGroupList).pipe(map(response => {
      // return response?.list;
      return response;
    }));
  }

  claUserList(): Observable<any> {
    return this.apiService.get(APIs.mainClaUserList).pipe(map(response => {
      // return response?.list;
      return response;
    }));
  }

  createNewCustomerServiceUser(body?: any): Observable<any> {
    return this.apiService.post(APIs.createNewServiceUser, body).pipe(map(response => {
      return response;
    }));
  }

  getServiceUsersList(): Observable<any> {
    return this.apiService.get(APIs.serviceUserList).pipe(map(response => {
      // return response?.list;
      return response;
    }));
  }

  removeCustomerServiceUserOnlyFromGroup(id: string, groupId: string): Observable<any> {
    return this.apiService.delete(APIs.removeCustomerFromOneGroup + '?memberId=' + id + '&groupId=' + groupId).pipe(map(response => {
      return response;
    }));
  }

  removeCustomerServiceUser(id: string): Observable<any> {
    return this.apiService.delete(APIs.removeCustomerServiceUser + '?memberId=' + id).pipe(map(response => {
      return response;
    }));
  }

  userListFromGroup(id: string): Observable<any> {
    return this.apiService.get(APIs.getGroupByUserList + '?groupId=' + id).pipe(map(response => {
      return response;
    }));
  }

  getMemberDetailsSingle(id: string): Observable<any> {
    return this.apiService.get(APIs.getSingleMemberDetails + '?memberId=' + id).pipe(map(response => {
      return response;
    }));
  }

  updateNewCustomerServiceUser(body?: any): Observable<any> {
    return this.apiService.put(APIs.updateNewServiceUser, body).pipe(map(response => {
      return response;
    }));
  }

  changeServiceUserGroup(body?: any): Observable<any> {
    return this.apiService.post(APIs.changeServiceUserGroup, body).pipe(map(response => {
      return response;
    }));
  }
}
